import { ProductData, FieldMapping } from './CSVTypes';

export const processRowToProduct = (row: Record<string, string>, selectedMappings: FieldMapping[]): ProductData => {
    // Initialize product with empty values
    const mappedProduct: ProductData = {
        // Required fields
        collection_id: '',
        collection_name: '',
        product_id: '',
        product_handle: '',
        product_title: '',
        variant_id: '',
        variant_sku: '',
        variant_title: '',

        // Optional fields
        collection_image: undefined,
        product_description: undefined,
        product_vendor: undefined,
        product_category: undefined,
        product_type: undefined,
        product_tags: undefined,
        product_status: undefined,
        product_image_src: undefined,
        variant_price: undefined,
        variant_compare_at_price: undefined,
        variant_inventory_quantity: undefined,
        variant_image_src: undefined,
        option1_name: undefined,
        option1_value: undefined,
        option2_name: undefined,
        option2_value: undefined,
        option3_name: undefined,
        option3_value: undefined,
        option4_name: undefined,
        option4_value: undefined,
    };

    // Apply field mappings to transform CSV data to backend format
    selectedMappings.forEach((mapping) => {
        const fieldName = mapping.customName || mapping.aspireField;
        const csvValue = row[mapping.csvColumn] || '';

        if (!csvValue) return; // Skip empty values

        switch (fieldName.toLowerCase()) {
            // Required fields
            case 'collection id':
                mappedProduct.collection_id = csvValue;
                break;
            case 'collection name':
                mappedProduct.collection_name = csvValue;
                break;
            case 'product id':
                mappedProduct.product_id = csvValue;
                break;
            case 'product handle':
                mappedProduct.product_handle = csvValue;
                break;
            case 'product title':
                mappedProduct.product_title = csvValue;
                break;
            case 'variant id':
                mappedProduct.variant_id = csvValue;
                break;
            case 'variant sku':
                mappedProduct.variant_sku = csvValue;
                break;
            case 'variant title':
                mappedProduct.variant_title = csvValue;
                break;

            // Optional fields
            case 'collection image':
                mappedProduct.collection_image = csvValue;
                break;
            case 'product description':
                mappedProduct.product_description = csvValue;
                break;
            case 'product vendor':
                mappedProduct.product_vendor = csvValue;
                break;
            case 'product category':
                mappedProduct.product_category = csvValue;
                break;
            case 'product type':
                mappedProduct.product_type = csvValue;
                break;
            case 'product tags':
                // Convert $-separated string to array
                mappedProduct.product_tags = csvValue.split('$').map((tag) => tag.trim()).filter((tag) => tag);
                break;
            case 'product status':
                mappedProduct.product_status = csvValue;
                break;
            case 'product image src':
                // Convert $-separated string to array
                mappedProduct.product_image_src = csvValue.split('$').map((url) => url.trim()).filter((url) => url);
                break;
            case 'variant price':
                mappedProduct.variant_price = csvValue;
                break;
            case 'variant compare at price':
                mappedProduct.variant_compare_at_price = csvValue;
                break;
            case 'variant inventory quantity':
                mappedProduct.variant_inventory_quantity = parseInt(csvValue, 10) || 0;
                break;
            case 'variant image src':
                // Convert $-separated string to array
                mappedProduct.variant_image_src = csvValue.split('$').map((url) => url.trim()).filter((url) => url);
                break;
            case 'option1 name':
                mappedProduct.option1_name = csvValue;
                break;
            case 'option1 value':
                mappedProduct.option1_value = csvValue;
                break;
            case 'option2 name':
                mappedProduct.option2_name = csvValue;
                break;
            case 'option2 value':
                mappedProduct.option2_value = csvValue;
                break;
            case 'option3 name':
                mappedProduct.option3_name = csvValue;
                break;
            case 'option3 value':
                mappedProduct.option3_value = csvValue;
                break;
            case 'option4 name':
                mappedProduct.option4_name = csvValue;
                break;
            case 'option4 value':
                mappedProduct.option4_value = csvValue;
                break;
            default:
                // Store additional custom fields
                mappedProduct[fieldName.toLowerCase().replace(/\s+/g, '_')] = csvValue;
        }
    });

    return mappedProduct;
};
